/**
 * Allows type safe access to array.
 * @param arr
 */
export const arrayHead = <T>(arr: T[] | readonly T[]): T | undefined => arr[0];
